import dayjs from 'dayjs';
import 'dayjs/locale/it';
import relativeTime from 'dayjs/plugin/relativeTime';

// Configuriamo dayjs
dayjs.locale('it');
dayjs.extend(relativeTime);

export const formatDate = (date) => {
    if (!date) return '';
    return dayjs(date).format('DD/MM/YYYY HH:mm');
};

export const formatTimeAgo = (date) => {
    if (!date) return '';
    return dayjs(date).fromNow();
};

export const formatShortDate = (date) => {
    if (!date) return '';
    return dayjs(date).format('DD/MM/YY');
};

export const formatISODate = (date) => {
    if (!date) return '';
    return dayjs(date).format('YYYY-MM-DD');
};

export const isValidDate = (date) => {
    return dayjs(date).isValid();
};

export const addDays = (date, days) => {
    return dayjs(date).add(days, 'day').toDate();
};

export const subtractDays = (date, days) => {
    return dayjs(date).subtract(days, 'day').toDate();
};

export const startOfDay = (date) => {
    return dayjs(date).startOf('day').toDate();
};

export const endOfDay = (date) => {
    return dayjs(date).endOf('day').toDate();
}; 